<script setup lang="ts">
  withDefaults(
    defineProps<{
      tableClass?: string;
    }>(),
    {
      tableClass: 'min-w-full',
    }
  );
</script>

<template>
  <div
    class="overflow-y-visible bg-white-01 rounded-2xl border border-gray-02 overflow-x-auto"
  >
    <table :class="tableClass">
      <slot />
    </table>
  </div>
</template>
